import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBug } from '@fortawesome/pro-solid-svg-icons';

function ErrorMessage({ error, errorInfo, children }) {
  return (
    <div className="error-boundary-fallback">
      <div className="error-boundary-content">
        <div className="media loading-message text-muted">
          <FontAwesomeIcon icon={faBug} size="4x" className="mr-3" fixedWidth />
          <div className="media-body">
            <h2>Oops! Something went wrong.</h2>
            <p>
              We're sorry, but something unexpected happened. Our team has been
              notified. Please try again later.
            </p>
            {process.env.NODE_ENV === 'development' && error && (
              <p>
                <details className="error-details">
                  <summary>Error Details (Development)</summary>
                  <pre className="error-stack">
                    {error.toString()}
                    {errorInfo.componentStack}
                  </pre>
                </details>
              </p>
            )}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorMessage;
